import styled from '@emotion/styled';
import { theme } from './GlobalStyles';
import { ReactComponent as ArrowShort } from '../../images/svgs/arrow-short.svg';
import { Link } from 'gatsby';

interface PrimaryProps {
    fill?: boolean;
}

export const ButtonPrimary = styled.button<PrimaryProps>`
    background: ${({ fill }) => (fill ? `${theme.colors.green3}` : `none`)};
    color: ${({ fill }) => (fill ? `${theme.colors.gray1}` : `${theme.colors.green3}`)};
    border: ${({ fill }) =>
        fill ? `2px solid ${theme.colors.green3}` : `2px solid ${theme.colors.green3}`};
    font-size: 18px;
    border-radius: 0px;
    font-weight: 500;
    padding: 18px 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease-in;
    font-weight: 600;
    cursor: pointer;
    svg {
        width: 18px;
        transition: 0.2s ease-in;
        margin-right: 12px;
        fill: ${({ fill }) => (fill ? `${theme.colors.gray1}` : `${theme.colors.green3}`)};
    }
    &:hover {
        background: ${({ fill }) => (fill ? `none` : `${theme.colors.green3}`)};
        color: ${({ fill }) => (fill ? `${theme.colors.green3}` : `${theme.colors.gray1}`)};
        svg {
            fill: ${({ fill }) => (fill ? `${theme.colors.green3}` : `${theme.colors.gray1}`)};
        }
    }
`;

interface Color {
    color: string;
}

const StyledSecondaryButton = styled.button<Color>`
    border: none;
    cursor: pointer;
    text-transform: capitalize;
    background: none;
    line-height: 24px;
    padding-left: 0px;
    a {
        display: flex;
        align-items: center;
        font-weight: 800;
        font-size: 18px;
        color: ${({ color }) => color === 'green' && `${theme.colors.green3}`};
        color: ${({ color }) => color === 'yellow' && `${theme.colors.yellow3}`};
    }
    svg {
        color: ${({ color }) => color === 'green' && `${theme.colors.green3}`};
        color: ${({ color }) => color === 'yellow' && `${theme.colors.yellow3}`};
        fill: ${({ color }) => color === 'green' && `${theme.colors.green3}`};
        fill: ${({ color }) => color === 'yellow' && `${theme.colors.yellow3}`};

        width: 16px;
    }
    div {
        margin-left: 16px;
        padding: 14px;
        display: flex;
        transition: 0.2s ease-in;
        align-items: center;
        justify-content: center;
        border-radius: 200px;
        border: ${({ color }) => color === 'green' && `2px solid ${theme.colors.green3}`};
        border: ${({ color }) => color === 'yellow' && `2px solid ${theme.colors.yellow3}`};
    }
    &:hover {
        div {
            transform: translateX(5px);
        }
    }
`;

interface Props {
    children: string | React.ReactNode;
    color: 'green' | 'yellow';
    className?: string;
    link: string;
}
export const SecondaryButton = ({ children, color, link }: Props) => {
    return (
        <StyledSecondaryButton color={color}>
            <Link to={link}>
                {children}
                <div>
                    <ArrowShort />
                </div>
            </Link>
        </StyledSecondaryButton>
    );
};
